module.exports = {
    palette: {
        primary: '#1A87D7',
        black: '#00293B',
        black1: '#14284A',
        gray: '#666666',
        'bg-gray': '#FBFBFD',
    },
};
